import React, { FC } from 'react'
import { Tag } from '@wmgtech/legato'
import { useReactiveVar } from '@apollo/client'
import { currentUserVar } from 'modulesCommon/store'
import useZoneTag from 'modulesCommon/serviceHooks/useZoneTag'

import { TourLabelProps } from './TourLabel.props'
import styles from './TourLabel.module.scss'

const TourLabel: FC<TourLabelProps> = ({ tour }) => {
  const { label } = useZoneTag(tour?.artist?.label?.id)
  const currentUser = useReactiveVar(currentUserVar)
  const isSameLabel = currentUser?.label_id === `${tour?.artist?.label?.id}`
  return (
    <Tag
      size={'xs'}
      removable={false}
      rounded
      text={label?.alias || ''}
      colorType={isSameLabel ? 'white' : 'dark'}
      containerStyle={isSameLabel ? 'outline' : 'solid'}
      className={styles.tag}
      tooltip
      tooltipText={label?.name || ''}
    />
  )
}

export default TourLabel
